export default __webpack_public_path__ + "static/media/notification.60f7268a.wav";